import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';
import { CSSProperties, css } from 'styled-components';

export const typographyMappedProperties = {
  fontFamily: true,
  fontSize: true,
  fontWeight: true,
  lineHeight: true,
  letterSpacing: true,
  fontStyle: true,
  textAlign: true,
  textTransform: true,
  textDecoration: true,
  whiteSpace: true,
  wordBreak: true,
};

export type WithTypographyProps = {
  fontFamily?: StyledPropType<'Muli' | 'Roboto'>;
  fontSize?: StyledPropType<CSSProperties['fontSize']>;
  fontWeight?: StyledPropType<CSSProperties['fontWeight']>;
  lineHeight?: StyledPropType<CSSProperties['lineHeight']>;
  letterSpacing?: StyledPropType<CSSProperties['letterSpacing']>;
  textAlign?: StyledPropType<CSSProperties['textAlign']>;
  fontStyle?: StyledPropType<CSSProperties['fontStyle']>;
  textTransform?: StyledPropType<CSSProperties['textTransform']>;
  textDecoration?: StyledPropType<CSSProperties['textDecoration']>;
  whiteSpace?: StyledPropType<CSSProperties['whiteSpace']>;
  wordBreak?: StyledPropType<CSSProperties['wordBreak']>;
};

export const withTypography = createExtractCssFromProps(
  typographyMappedProperties,
);

export const withOneLineEllipsis = css`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
